/*
  Resource Library — data source.

  The one place the theme knows where results come from. Everything else calls
  window.LibraryDataSource.search(params) / .save(handle, op) and gets the
  LibraryResponse the app proxy returns. The proxy powers every load — first
  paint and every filter / search / sort / page change.
*/
const LIBRARY_PROXY_PATH = '/apps/wpiinc/library';

(function () {
  'use strict';

  var ARRAY_PARAMS = ['category', 'product_line'];

  function serialise(params) {
    var s = new URLSearchParams();
    if (params.q) s.set('q', params.q);
    ARRAY_PARAMS.forEach(function (k) {
      var v = params[k];
      if (Array.isArray(v) && v.length) s.set(k, v.join(','));
      else if (typeof v === 'string' && v) s.set(k, v);
    });
    if (params.sort) s.set('sort', params.sort);
    if (params.saved) s.set('saved', '1');
    if (params.page && params.page > 1) s.set('page', String(params.page));
    if (params.per_page) s.set('per_page', String(params.per_page));
    return s.toString();
  }

  var ProxyDataSource = {
    async search(params, options) {
      var url = LIBRARY_PROXY_PATH + '?' + serialise(params);
      var res;
      try {
        res = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            // Dev store runs the app behind ngrok; skip its browser interstitial.
            'ngrok-skip-browser-warning': 'true'
          },
          signal: options && options.signal
        });
      } catch (e) {
        if (e.name === 'AbortError') throw e;
        var err = new Error(e.message);
        err.code = 'network';
        throw err;
      }
      if (!res.ok) {
        var httpErr = new Error(res.status + ' ' + res.statusText);
        httpErr.code = 'http';
        throw httpErr;
      }
      var body;
      try {
        body = await res.json();
      } catch (e) {
        if (e.name === 'AbortError') throw e;
        var parseErr = new Error('Bad response');
        parseErr.code = 'parse';
        throw parseErr;
      }
      if (!body || !body.results || !body.pagination) {
        var shapeErr = new Error('Response did not match the library contract.');
        shapeErr.code = 'parse';
        throw shapeErr;
      }
      return body;
    },

    // Toggle a resource in the logged-in customer's saved list. The proxy reads
    // the verified logged_in_customer_id Shopify injects, so the browser never
    // says which customer — it can only act as itself.
    async save(handle, op) {
      var res;
      try {
        res = await fetch(LIBRARY_PROXY_PATH, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'ngrok-skip-browser-warning': 'true'
          },
          body: JSON.stringify({ handle: handle, op: op || 'toggle' })
        });
      } catch (e) {
        var err = new Error(e.message);
        err.code = 'network';
        throw err;
      }
      var body = null;
      try { body = await res.json(); } catch (e) { body = null; }
      if (res.status === 401) {
        var authErr = new Error('unauthenticated');
        authErr.code = 'unauthenticated';
        throw authErr;
      }
      if (!res.ok || !body || !body.ok) {
        var saveErr = new Error((body && body.detail) || 'save failed');
        saveErr.code = 'http';
        throw saveErr;
      }
      return body; // { ok, handle, saved, count }
    },

    toQueryString: serialise
  };

  window.LibraryDataSource = ProxyDataSource;
})();
